import { EditMode, getSxSViewStore } from 'owa-group-files-hub-store';
import { mutatorAction } from 'satcheljs';

const setEditStateAction = mutatorAction('setEditStateAction', function setEditStateAction(
    mode: EditMode,
    fileUrl?: string,
    editAllowed?: boolean
) {
    const wacFileEditState = getSxSViewStore().wacFileEditState;
    wacFileEditState.mode = mode;
    wacFileEditState.fileUrl = fileUrl;
    editAllowed != undefined && (wacFileEditState.editAllowed = editAllowed);
});

export default setEditStateAction;
